module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0094.jpg?v=d07f88d6";